export default {
  landing: {
    features: "機能",
    solutions: "ソリューション",
    pricing: "料金プラン",
    waitlist: "早期アクセス",
    faq: "よくある質問",
    contact: "お問い合わせ",
    about: "会社概要",
    tools: "無料ツール",
  },
  upload: "アップロード",
  history: "履歴",
  home: "ホーム",
  userMenu: {
    login: "ログイン",
    dashboard: "ダッシュボード",
    history: "履歴",
    logout: "ログアウト",
    themeMode: "テーマ",
    themeLight: "ライト",
    themeDark: "ダーク",
    themeSystem: "システム",
  },
};
